import { createLink, Link } from '@tanstack/react-router'
import styled, { css } from 'styled-components'

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
`

const selectedButtonStyles = css`
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: bold;
  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }
  &:active {
    background-color: ${({ theme }) => theme.forecast.activeButton};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

interface StyledLinkProps {
  $isSelected: boolean
  $isSelectedTab?: boolean
}

export const StyledLink = createLink(styled(Link)<StyledLinkProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.secondaryText};
  background-color: ${({ theme }) => theme.forecast.defaultGhostButton};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  outline: none;
  padding-left: 0.4rem;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverGhostButton};
  }
  &:active {
    background-color: ${({ theme }) => theme.forecast.activeGhostButton};
    color: ${({ theme }) => theme.forecast.defaultText};
    font-weight: 600;
  }
  ${({ $isSelected }) => $isSelected && selectedButtonStyles}

  ${({ $isSelectedTab }) =>
    $isSelectedTab &&
    css`
      box-shadow: inset 3px 0 0 ${({ theme }) => theme.forecast.highlight};
    `}

  &:focus {
    outline: 2px solid ${({ theme }) => theme.forecast.activeButton};
    outline-offset: 2px;
  }
`)
